import {
  AutoAwesome,
  Chair,
  Computer,
  Diamond,
  PanToolAlt,
} from "@mui/icons-material";
import demo from "../../Assets/Images/demo.jpg";
import topView from "../../Assets/Images/topview.jpg";

const caterlogueData = [
  {
    name: "computers and electronics",
    avatar: <Computer />,
    image: demo,
  },
  {
    name: "clothes and jewellery",
    avatar: <Diamond />,
    image: topView,
  },
  {
    name: "cars and motorcycles",
    avatar: <AutoAwesome />,
    image: demo,
  },
  {
    name: "machinery and equipment",
    avatar: <PanToolAlt />,
    image: topView,
  },
  {
    name: "home furniture",
    avatar: <Chair />,
    image: demo,
  },
];
export default caterlogueData;
